import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Members from "@/pages/Members";
import Captura from "@/pages/Captura";
import Gastos from "@/pages/Gastos";
import Cells from "@/pages/Cells";
import Consolidation from "@/pages/Consolidation";
import Reports from "@/pages/Reports";
import UsersAdmin from "@/pages/UsersAdmin";
import Solicitudes from "@/pages/Solicitudes";
import MiAgenda from "@/pages/MiAgenda";
import Koinonia from "@/pages/Koinonia";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-center"
            richColors
            closeButton
            toastOptions={{
              style: {
                fontFamily: "inherit",
                border: "1px solid #d9cfb8",
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="miembros" element={<Members />} />
              <Route path="captura" element={<Captura />} />
              <Route path="gastos" element={<Gastos />} />
              <Route path="celulas" element={<Cells />} />
              <Route path="consolidacion" element={<Consolidation />} />
              <Route path="solicitudes" element={<Solicitudes />} />
              <Route path="agenda" element={<MiAgenda />} />
              <Route path="koinonia" element={<Koinonia />} />
              <Route path="reportes" element={<Reports />} />
              <Route path="usuarios" element={<UsersAdmin />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
